import { OngoingSessionProvider, useOngoingSessionContext } from "./context";
import OngoingSessionModal from "./modal";

export const OngoingSession = {
  Modal: OngoingSessionModal,
  Provider: OngoingSessionProvider,
  useContext: useOngoingSessionContext,
};
